<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
    <div class="entity-config-shell d-flex flex-column gap-4 gap-lg-3 mx-auto mt-4">
        <section class="entity-config-top mb-1 rounded-4 overflow-hidden shadow-sm">
            <div class="entity-config-top-hero px-2 px-md-3 py-3">
                <div class="row g-2 align-items-start flex-nowrap">
                    <div class="col">
                        <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">
                            Notifications
                        </h1>
                        <p class="entity-page-subtitle text-white mb-0">
                            Define what triggers it, who hears about it, and how.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="container-fluid mt-4">

        <notification-stepper
            :active-step="active_step"
            @update-step="active_step = $event"
        >
        </notification-stepper>

    </div>
    <div class="container-fluid mt-4">
        <div class="row g-4 align-items-start">
            <div class="col-lg-8">
                <div v-show="active_step === 1">
                    <div class="card border-0 shadow-sm rounded-4">
                        <div class="card-body p-4">
                            <small class="text-uppercase fw-bold text-primary">
                                Step 1
                            </small>

                            <h3 class="fw-bold mt-2 mb-1">
                                General Information
                            </h3>

                            <p class="text-secondary mb-4">
                                Give your notification a meaningful name and configure its default settings.
                            </p>
                            <div class="row g-4">
                                <div class="col-md-6">

                                    <label class="form-label fw-semibold">
                                        Notification Name
                                        <span class="text-danger">*</span>
                                    </label>

                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter notification name"
                                        v-model="notification.name"
                                    >

                                    <small
                                        v-if="errors.name"
                                        class="text-danger"
                                    >
                                        {{ errors.name }}
                                    </small>
                                </div>
                                <div class="col-md-6">

                                    <label class="form-label fw-semibold">
                                        Priority
                                        <span class="text-danger">*</span>
                                    </label>

                                    <select
                                        class="form-select"
                                        v-model="notification.priority"
                                    >

                                        <option value="">
                                            Select Priority
                                        </option>

                                        <option
                                            v-for="priority in priority_options"
                                            :key="priority.value"
                                            :value="priority.value"
                                        >
                                            {{ priority.label }}
                                        </option>

                                    </select>

                                </div>
                                <div class="col-12">

                                    <label class="form-label fw-semibold">
                                        Description
                                    </label>

                                    <textarea
                                        class="form-control"
                                        rows="5"
                                        maxlength="500"
                                        placeholder="Describe this notification..."
                                        v-model="notification.description"
                                    ></textarea>

                                    <div class="text-end text-muted small mt-1">
                                        {{ notification.description.length }}/500
                                    </div>

                                </div>
                                <div class="col-12">
                                    <div class="card bg-light border-0 rounded-4">
                                        <div class="card-body">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div>

                                                    <h6 class="fw-bold mb-1">
                                                        Notification Status
                                                    </h6>

                                                    <small class="text-muted">
                                                        Active notifications will be processed by the Notification Engine.
                                                    </small>

                                                </div>

                                                <div class="form-check form-switch">

                                                    <input
                                                        class="form-check-input fs-4"
                                                        type="checkbox"
                                                        v-model="notification.is_active"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end mt-4">

                                <button
                                    type="button"
                                    class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-3 py-2"
                                    @click="active_step = 2"
                                >

                                    Next

                                    <i class="bi bi-arrow-right ms-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="active_step === 2">
                    <div class="card border-0 shadow-sm rounded-4">

                        <div class="card-body p-4">

                            <small class="text-uppercase fw-bold text-primary">
                                Step 2
                            </small>

                            <h3 class="fw-bold mt-2">
                                Configure Trigger
                            </h3>

                            <p class="text-secondary mb-4">
                                Choose the event that should cause this notification to be generated.
                            </p>
                            <div class="row g-4">
                                <div class="col-md-6">

                                    <label class="form-label fw-semibold">
                                        Event Type
                                        <span class="text-danger">*</span>
                                    </label>

                                    <select
                                        class="form-select"
                                        v-model="notification.event_type"
                                    >

                                        <option value="">
                                            Select Event Type
                                        </option>

                                        <option
                                            v-for="event in event_type_options"
                                            :key="event.value"
                                            :value="event.value"
                                        >
                                            {{ event.label }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-6">

                                    <label class="form-label fw-semibold ">
                                        Event Trigger
                                        <span class="text-danger">*</span>
                                    </label>

                                    <select
                                        class="form-select fs-6"
                                        v-model="notification.event_trigger"
                                    >

                                        <option value="">
                                            Select Event Trigger
                                        </option>

                                        <option
                                            v-for="trigger in event_trigger_options"
                                            :key="trigger.value"
                                            :value="trigger.value"
                                        >
                                            {{ trigger.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card border-0 shadow-sm rounded-4 mt-4">

                        <div class="card-body p-4">

                            <div class="d-flex justify-content-between align-items-center mb-3">

                                <div>

                                    <h4 class="fw-bold mb-1">
                                        Conditions
                                    </h4>

                                    <small class="text-muted">
                                        Add optional filters to control when this notification should execute.
                                    </small>

                                </div>
                                <button
                                    type="button"
                                    class="btn entity-assign-btn btn-sm"
                                    @click="add_condition"
                                >

                                    <i class="bi bi-plus-circle me-2"></i>

                                    Add Condition

                                </button>
                            </div>
                            <div
                                v-if="notification.conditions.length === 0"
                                class="text-center py-5"
                            >

                                <i class="bi bi-funnel display-4 text-secondary"></i>

                                <p class="text-muted mt-3 mb-0">
                                    No conditions added.
                                </p>
                            </div>
                            <div
                                v-for="(condition, index) in notification.conditions"
                                :key="index"
                                class="card border rounded-3 mb-3"
                            >
                                <div class="card-body">
                                    <div class="row g-3">
                                        <div class="col-md-3">

                                            <label class="form-label">
                                                Field
                                            </label>

                                            <select
                                                class="form-select"
                                                v-model="condition.field"
                                            >

                                                <option value="">
                                                    Select Field
                                                </option>

                                                <option
                                                    v-for="field in field_options"
                                                    :key="field.value"
                                                    :value="field.value"
                                                >
                                                    {{ field.label }}
                                                </option>

                                            </select>

                                        </div>
                                        <div class="col-md-3">

                                            <label class="form-label">
                                                Operator
                                            </label>

                                            <select
                                                class="form-select"
                                                v-model="condition.operator"
                                            >

                                                <option value="">
                                                    Select Operator
                                                </option>

                                                <option
                                                    v-for="operator in operator_options"
                                                    :key="operator.value"
                                                    :value="operator.value"
                                                >
                                                    {{ operator.label }}
                                                </option>

                                            </select>

                                        </div>
                                        <div class="col-md-5">

                                            <label class="form-label">
                                                Value
                                            </label>

                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Enter comparison value"
                                                v-model="condition.value"
                                            >

                                        </div>
                                        <div class="col-md-1 d-flex align-items-end">

                                            <button
                                                type="button"
                                                class="btn btn-outline-danger w-100"
                                                @click="remove_condition(index)"
                                            >

                                                <i class="bi bi-trash"></i>

                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-4">

                        <button
                            type="button"
                            class="btn entity-assign-btn btn-sm"
                            @click="active_step = 1"
                        >
                            <i class="bi bi-arrow-left me-2"></i>

                            Back
                        </button>
                        <button
                            type="button"
                            class="btn entity-assign-btn btn-sm"
                            @click="active_step = 3"
                        >

                            Next

                            <i class="bi bi-arrow-right ms-2"></i>
                        </button>
                    </div>
                </div>
                <div v-show="active_step === 3">

                    <div class="card border-0 shadow-sm rounded-4">

                        <div class="card-body p-4">

                            <small class="text-uppercase fw-bold text-primary">
                                Step 3
                            </small>

                            <h3 class="fw-bold mt-2">
                                Notification Recipients
                            </h3>

                            <p class="text-secondary mb-4">
                                Choose who should receive this notification.
                            </p>
                            <div
                                v-for="(recipient, index) in notification.recipients"
                                :key="index"
                                class="card border rounded-4 mb-4"
                            >
                                <div class="card-body">
                                    <div class="d-flex justify-content-between mb-4">

                                        <h5 class="fw-bold mb-0">
                                            Recipient Group {{ index + 1 }}
                                        </h5>

                                        <button
                                            v-if="notification.recipients.length > 1"
                                            type="button"
                                            class="btn btn-outline-danger btn-sm"
                                            @click="remove_recipient(index)"
                                        >

                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </div>
                                    <div class="row g-4">
                                        <div class="col-md-4">

                                            <label class="form-label fw-semibold">
                                                Recipient Type
                                                <span class="text-danger">*</span>
                                            </label>

                                            <select
                                                class="form-select"
                                                v-model="recipient.recipient_type"
                                                @change="recipient_type_changed(recipient)"
                                            >

                                                <option value="">
                                                    Select Type
                                                </option>
                                                <option
                                                    v-for="type in recipient_type_options"
                                                    :key="type.value"
                                                    :value="type.value"
                                                >
                                                    {{ type.label }}
                                                </option>

                                            </select>
                                        </div>
                                        <div
                                            v-if="recipient.recipient_type === 'user'"
                                            class="col-md-4"
                                        >

                                            <label class="form-label fw-semibold">
                                                Select User
                                            </label>

                                            <select
                                                class="form-select"
                                                v-model="recipient.user_id"
                                            >

                                                <option value="">
                                                    Select User
                                                    <span class="text-danger">*</span>
                                                </option>

                                                <option
                                                    v-for="user in users"
                                                    :key="user.id"
                                                    :value="user.id"
                                                >
                                                    {{ user.name }}
                                                </option>

                                            </select>
                                        </div>
                                        <div
                                            v-if="recipient.recipient_type === 'role'"
                                            class="col-md-4"
                                        >

                                            <label class="form-label fw-semibold">
                                                Select Role
                                            </label>
                                            <select
                                                class="form-select"
                                                v-model="recipient.role_id"
                                            >

                                                <option value="">
                                                    Select Role
                                                </option>
                                                <option
                                                    v-for="role in user_roles"
                                                    :key="role.id"
                                                    :value="role.id"
                                                >
                                                    {{ role.role }}
                                                </option>

                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button
                                type="button"
                                class="btn entity-assign-btn btn-sm"
                                @click="add_recipient_group"
                            >

                                <i class="bi bi-plus-circle me-2"></i>

                                Add Recipient Group
                            </button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-4">

                        <button
                            type="button"
                            class="btn entity-assign-btn btn-sm"
                            @click="active_step = 2"
                        >

                            <i class="bi bi-arrow-left me-2"></i>

                            Back

                        </button>
                        <button
                            type="button"
                            class="btn entity-assign-btn btn-sm"
                            @click="active_step = 4"
                        >

                            Next

                            <i class="bi bi-arrow-right ms-2"></i>
                        </button>
                    </div>
                </div>
                <div v-show="active_step === 4">

                    <!-- CHANNELS -->
                    <div class="card border-0 shadow-sm rounded-4">

                        <div class="card-body p-4">

                            <small class="text-uppercase fw-bold text-primary">
                                Step 4
                            </small>

                            <h3 class="fw-bold mt-2">
                                Delivery Channels
                            </h3>

                            <p class="text-secondary mb-4">
                                Select one or more channels.
                            </p>

                            <div class="row g-4">
                                <div class="col-md-3">
                                    <label class="channel-card p-4 text-center w-100">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="EMAIL"
                                            v-model="notification.channels"
                                        >
                                        <div class="mt-3">
                                            <i class="bi bi-envelope-fill display-6 text-primary"></i>
                                            <h5 class="mt-3">
                                                Email
                                            </h5>
                                        </div>
                                    </label>
                                </div>
                                <div class="col-md-3">
                                    <label class="channel-card p-4 text-center w-100">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="IN_APP"
                                            v-model="notification.channels"
                                        >
                                        <div class="mt-3">
                                            <i class="bi bi-bell-fill display-6 text-success"></i>
                                            <h5 class="mt-3">
                                                In-App
                                            </h5>
                                        </div>
                                    </label>
                                </div>

                                <div class="col-md-3">

                                    <label class="channel-card p-4 text-center w-100">

                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="SMS"
                                            v-model="notification.channels"
                                        >
                                        <div class="mt-3">

                                            <i class="bi bi-chat-dots-fill display-6 text-warning"></i>

                                            <h5 class="mt-3">
                                                SMS
                                            </h5>
                                        </div>
                                    </label>
                                </div>
                                <div class="col-md-3">

                                    <label class="channel-card p-4 text-center w-100">

                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="WEBHOOK"
                                            v-model="notification.channels"
                                        >

                                        <div class="mt-3">
                                            <i class="bi bi-globe display-6 text-info"></i>
                                            <h5 class="mt-3">
                                                Webhook
                                            </h5>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="notification.channels.includes('EMAIL')"
                        class="card shadow-sm border-0 rounded-4 mt-4"
                    >

                        <div class="card-body p-4">
                            <h5 class="fw-bold">
                                <i class="bi bi-envelope-fill text-primary me-2"></i>
                                Email Configuration
                            </h5>
                            <label class="form-label fw-semibold mt-3">
                                Subject
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Enter email subject"
                                v-model="notification_message.email.subject"
                            >
                            <label class="form-label fw-semibold mt-4">
                                Message
                            </label>

                            <textarea
                                rows="6"
                                class="form-control"
                                placeholder="Enter email message..."
                                v-model="notification_message.email.body"
                            ></textarea>
                        </div>
                    </div>
                    <div
                        v-if="notification.channels.includes('IN_APP')"
                        class="card shadow-sm border-0 rounded-4 mt-4"
                    >
                        <div class="card-body p-4">
                            <h5 class="fw-bold">
                                <i class="bi bi-bell-fill text-success me-2"></i>

                                In-App Configuration
                            </h5>
                            <label class="form-label fw-semibold mt-3">
                                Subject
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Enter notification subject"
                                v-model="notification_message.in_app.subject"
                            >
                            <label class="form-label fw-semibold mt-4">
                                Message
                            </label>
                            <textarea
                                rows="6"
                                class="form-control"
                                placeholder="Enter in-app message..."
                                v-model="notification_message.in_app.body"
                            ></textarea>
                        </div>
                    </div>
                    <div
                        v-if="notification.channels.includes('SMS')"
                        class="card shadow-sm border-0 rounded-4 mt-4"
                    >
                        <div class="card-body p-4">
                            <h5 class="fw-bold">
                                <i class="bi bi-chat-dots-fill text-warning me-2"></i>
                                SMS Configuration
                            </h5>
                            <label class="form-label fw-semibold mt-3">
                                Subject
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Enter SMS subject"
                                v-model="notification_message.sms.subject"
                            >
                            <label class="form-label fw-semibold mt-4">
                                Message
                            </label>
                            <textarea
                                rows="5"
                                class="form-control"
                                placeholder="Enter SMS message..."
                                v-model="notification_message.sms.message"
                            ></textarea>
                        </div>
                    </div>
                    <div
                        v-if="notification.channels.includes('WEBHOOK')"
                        class="card shadow-sm border-0 rounded-4 mt-4"
                    >
                        <div class="card-body p-4">
                            <h5 class="fw-bold">
                                <i class="bi bi-globe text-info me-2"></i>
                                Webhook Configuration
                            </h5>
                            <label class="form-label fw-semibold mt-3">
                                Endpoint URL
                            </label>
                            <input
                                type="url"
                                class="form-control"
                                placeholder="https://example.com/webhook"
                                v-model="notification_message.webhook.url"
                            >
                            <label class="form-label fw-semibold mt-4">
                                Payload
                            </label>
                            <textarea
                                rows="6"
                                class="form-control"
                                placeholder="Enter webhook payload..."
                                v-model="notification_message.webhook.body"
                            ></textarea>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-4">
                        <button
                            type="button"
                            class="btn entity-assign-btn btn-sm"
                            @click="active_step = 3"
                        >
                            <i class="bi bi-arrow-left me-2"></i>
                            Back
                        </button>
                        <button
                            type="button"
                            class="btn entity-assign-btn btn-sm"
                            @click="active_step = 5"
                        >
                            Next
                            <i class="bi bi-arrow-right ms-2"></i>
                        </button>
                    </div>
                </div>
                <div v-show="active_step === 5">
                    <div class="card border-0 shadow-sm rounded-4">
                        <div class="card-body p-4">
                            <small class="text-uppercase fw-bold text-primary">
                                Step 5
                            </small>
                            <h3 class="fw-bold mt-2">
                                Scope &amp; Review
                            </h3>
                            <p class="text-muted mb-4">
                                Review your notification before saving.
                            </p>
                            <div class="card border rounded-3">
                                <div class="card-header bg-light">
                                    <strong>
                                        Review Summary
                                    </strong>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label class="text-muted">
                                                Notification Name
                                            </label>
                                            <p class="fw-semibold">
                                                {{ notification.name || 'Not specified' }}
                                            </p>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label class="text-muted">
                                                Priority
                                            </label>
                                            <p>
                                                {{ notification.priority || 'Not specified' }}
                                            </p>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label class="text-muted">
                                                Event Type
                                            </label>
                                            <p>
                                                {{ notification.event_type || 'Not specified' }}
                                            </p>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label class="text-muted">
                                                Event Trigger
                                            </label>
                                            <p>
                                                {{ notification.event_trigger || 'Not specified' }}
                                            </p>
                                        </div>
                                    </div>
                                    <hr>
                                    <h6 class="fw-bold mb-3">
                                        Channels
                                    </h6>
                                    <div
                                        v-if="notification.channels && notification.channels.length > 0"
                                        class="mb-4"
                                    >
                                        <span
                                            v-for="channel in notification.channels"
                                            :key="channel"
                                            class="badge bg-light text-dark border me-2"
                                        >
                                            {{ channel }}
                                        </span>
                                    </div>
                                    <div
                                        v-else
                                        class="text-muted small mb-4"
                                    >
                                        No channels selected.
                                    </div>
                                    <hr>
                                    <h6 class="fw-bold mb-3">
                                        Recipient Groups
                                    </h6>
                                    <div
                                        v-if="notification.recipients && notification.recipients.length > 0"
                                    >
                                        <div
                                            v-for="(recipient, index) in notification.recipients"
                                            :key="index"
                                            class="border rounded-3 p-3 mb-3"
                                        >
                                            <div class="d-flex justify-content-between align-items-center mb-3">

                                                <strong>
                                                    Recipient {{ index + 1 }}
                                                </strong>

                                                <span class="badge bg-light text-dark border">
                                                    {{ get_recipient_type_label(recipient.recipient_type) }}
                                                </span>

                                            </div>
                                            <div
                                                v-if="recipient.recipient_type === 'user'"
                                                class="row"
                                            >

                                                <div class="col-md-6">

                                                    <small class="text-muted d-block">
                                                        Recipient Type
                                                    </small>

                                                    <strong>
                                                        {{ get_recipient_type_label(recipient.recipient_type) }}
                                                    </strong>

                                                </div>
                                                <div class="col-md-6">

                                                    <small class="text-muted d-block">
                                                        User
                                                    </small>

                                                    <strong>
                                                        {{ get_recipient_user_name(recipient.user_id) }}
                                                    </strong>
                                                </div>
                                            </div>

                                            <div
                                                v-else-if="recipient.recipient_type === 'role'"
                                                class="row"
                                            >
                                               <div class="col-md-6">
                                                    <small class="text-muted d-block">
                                                        Recipient Type
                                                    </small>

                                                    <strong>
                                                        {{ get_recipient_type_label(recipient.recipient_type) }}
                                                    </strong>
                                                </div>

                                                <div class="col-md-6">
                                                    <small class="text-muted d-block">
                                                        Role
                                                    </small>

                                                    <strong>
                                                        {{ get_recipient_role_name(recipient.role_id) }}
                                                    </strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-else
                                        class="text-muted small"
                                    >
                                        No recipients selected.
                                    </div>
                                    <hr>
                                    <h6 class="fw-bold">
                                        Status
                                    </h6>

                                    <span
                                        class="badge"
                                        :class="notification.is_active ? 'bg-success' : 'bg-secondary'"
                                    >
                                        {{ notification.is_active ? 'Active' : 'Inactive' }}
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mt-4">

                                <button
                                    type="button"
                                    class="btn entity-assign-btn btn-sm"
                                    @click="active_step = 4"
                                >
                                    <i class="bi bi-arrow-left me-2"></i>

                                    Back
                                </button>
                                <button
                                    type="button"
                                    class="btn entity-assign-btn btn-sm"
                                    @click="create_notification_rule"
                                >

                                    <i class="bi bi-check-circle me-2"></i>

                                    Save Notification

                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

<div class="col-12 col-lg-4">
    <div class="card border-0 shadow-sm rounded-4 h-100">
        <div class="card-body p-3 p-md-4">
            <div
                class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3"
            >
                <div class="flex-grow-1">
                    <h5 class="fw-bold mb-1">
                        <i class="bi bi-bell-fill text-entity-assign me-2"></i>
                        All Notifications
                    </h5>

                    <p class="text-muted small mb-0">
                        Existing notification rules
                    </p>
                </div>
                <div>
                    
                </div>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                    <div class="d-flex gap-1 flex-wrap">

                        <button
                            type="button"
                            class="btn btn-sm"
                            :class="notification_view === 'active'
                                ? 'entity-assign-btn'
                                : 'btn-outline-primary'"
                            @click="notification_view = 'active'"
                        >
                            Active
                        </button>

                        <button
                            type="button"
                            class="btn btn-sm"
                            :class="notification_view === 'inactive'
                                ? 'entity-assign-btn'
                                : 'btn-outline-primary'"
                            @click="notification_view = 'inactive'"
                        >
                            Inactive
                        </button>

                    </div>
                    <span class="badge bg-primary">
                        {{ current_notification_count }}
                    </span>
                </div>   
            </div>
            
            <div class="mt-3">
                        <input
                            v-model="notification_search"
                            type="search"
                            class="form-control form-control-sm rounded-small"
                            placeholder="Search notifications..."
                        />
                    </div>  
                    <hr>
                            <div
                        v-if="loading"
                        class="text-center py-4"
                    >
                        <div class="spinner-border text-primary"></div>

                        <p class="text-muted small mt-2 mb-0">
                            Loading notifications...
                        </p>
                    </div>

                    <div
                        v-else-if="filtered_notifications.length > 0"
                        class="notification-list"
                    >
                        <div
                            v-for="notifications_item in filtered_notifications"
                            :key="notifications_item.id"
                            class="border rounded-3 p-3 mb-3 notification-item"
                            @click="open_notification_modal(notifications_item)"
                        >
                            <div
                                class="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-2"
                            >
                                <strong class="notification-name">
                                    {{ notifications_item.name }}
                                </strong>

                                <span
                                    class="badge flex-shrink-0"
                                    :class="
                                        notifications_item.is_active
                                            ? 'bg-success'
                                            : 'bg-secondary'
                                    "
                                >
                                    {{
                                        notifications_item.is_active
                                            ? 'Active'
                                            : 'Inactive'
                                    }}
                                </span>
                            </div>

                            <small class="text-muted d-block mt-2 notification-description">
                                {{
                                    notifications_item.description ||
                                    'No description'
                                }}
                            </small>

                            <div class="mt-2">
                                <span class="badge bg-light text-dark border">
                                    {{ notifications_item.priority }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        class="text-center text-muted py-5"
                    >
                        <i class="bi bi-bell-slash fs-2"></i>

                        <p class="mb-0 mt-2">
                            No notifications found.
                        </p>
                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

<teleport to="body">

    <div
        class="modal fade"
        id="notification_details_modal"
        tabindex="-1"
        aria-labelledby="notification_details_modal_label"
        aria-hidden="true"
    >

        <div
            class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable"
        >

            <div class="modal-content bg-white rounded-4 shadow-lg">
                <div class="modal-header border-bottom-0 cute-header shadow-lg">
                    <p
                        class="modal-title text-white text-xs mb-0"
                        id="notification_details_modal_label"
                    >
                        Notification Details
                    </p>
                    <button
                        type="button"
                        class="modal-btn-close btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6 mb-3">

                            <label class="modal-form-label form-label text-xxs">
                                Name:
                            </label>

                            <input
                                type="text"
                                v-model="selected_notification.name"
                                class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                            >

                        </div>

                        <div class="col-md-6 mb-3">

                            <label class="modal-form-label form-label text-xxs">
                                Priority:
                            </label>

                            <select
                                v-model="selected_notification.priority"
                                class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                            >

                                <option value="">
                                    Select Priority
                                </option>

                                <option
                                    v-for="priority in priority_options"
                                    :key="priority.value"
                                    :value="priority.value"
                                >
                                    {{ priority.label }}
                                </option>

                            </select>

                        </div>

                    </div>

                    <div class="modal-form-group form-group mb-3">

                        <label class="modal-form-label form-label text-xxs">
                            Description:
                        </label>

                        <textarea
                            v-model="selected_notification.description"
                            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm"
                            rows="3"
                        ></textarea>

                    </div>
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label class="modal-form-label form-label text-xxs">
                                Event Type:
                            </label>
                            <select
                                v-model="selected_notification.event_type"
                                class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                            >
                                <option value="">
                                    Select Event Type
                                </option>
                                <option
                                    v-for="event_type in event_type_options"
                                    :key="event_type.value"
                                    :value="event_type.value"
                                >
                                    {{ event_type.label }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-3">

                            <label class="modal-form-label form-label text-xxs">
                                Event Trigger:
                            </label>
                            <select
                                v-model="selected_notification.event_trigger"
                                class="modal-form-control form-select text-xs rounded-small p-2 shadow-sm"
                            >
                                <option value="">
                                    Select Event Trigger
                                </option>
                                <option
                                    v-for="trigger in event_trigger_options"
                                    :key="trigger.value"
                                    :value="trigger.value"
                                >
                                    {{ trigger.label }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="form-check mb-4">

                      <div class="form-check form-switch d-flex align-items-center gap-2">
                        <input
                            id="notification_active"
                            v-model="selected_notification.is_active"
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                        >

                        <label
                            class="form-check-label text-xs"
                            for="notification_active"
                        >
                            {{ selected_notification.is_active ? 'Active' : 'Inactive' }}
                        </label>
                      </div>
                    </div>

                    <div class="mb-4">

                        <h6 class="modal-form-label form-label text-xxs">
                            Channels
                        </h6>

                        <div class="row g-2">
                            <div class="col-md-3">

                                <label
                                    class="border rounded-3 p-3 w-100 h-100"
                                    style="cursor: pointer;"
                                >

                                    <div class="form-check">

                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="EMAIL"
                                            v-model="selected_notification.channels"
                                        >

                                        <span class="form-check-label text-xs fw-semibold">
                                            <i class="bi bi-envelope-fill text-primary me-1"></i>
                                            Email
                                        </span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-md-3">

                                <label
                                    class="border rounded-3 p-3 w-100 h-100"
                                    style="cursor: pointer;"
                                >

                                    <div class="form-check">

                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="IN_APP"
                                            v-model="selected_notification.channels"
                                        >

                                        <span class="form-check-label text-xs fw-semibold">
                                            <i class="bi bi-bell-fill text-success me-1"></i>
                                            In-App
                                        </span>

                                    </div>

                                </label>

                            </div>
                            <div class="col-md-3">

                                <label
                                    class="border rounded-3 p-3 w-100 h-100"
                                    style="cursor: pointer;"
                                >

                                    <div class="form-check">

                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="SMS"
                                            v-model="selected_notification.channels"
                                        >

                                        <span class="form-check-label text-xs fw-semibold">
                                            <i class="bi bi-chat-dots-fill text-warning me-1"></i>
                                            SMS
                                        </span>
                                    </div>
                                </label>
                            </div>
                            <div class="col-md-3">

                                <label
                                    class="border rounded-3 p-3 w-100 h-100"
                                    style="cursor: pointer;"
                                >

                                    <div class="form-check">

                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            value="WEBHOOK"
                                            v-model="selected_notification.channels"
                                        >

                                        <span class="form-check-label text-xs fw-semibold">
                                            <i class="bi bi-globe text-info me-1"></i>
                                            Webhook
                                        </span>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>

                   <div class="mb-4">

    <div class="mb-2">
        <h6 class="modal-form-label form-label text-xxs">
            Recipients
        </h6>
    </div>

    <div
        v-if="
            selected_notification.recipients &&
            selected_notification.recipients.length > 0
        "
    >
        <div
            v-for="(recipient, index) in selected_notification.recipients"
            :key="recipient.id || index"
            class="border rounded-3 p-3 mb-3"
        >

            <div
                class="d-flex justify-content-between align-items-center mb-3"
            >

                <strong class="text-xs">
                    Recipient {{ index + 1 }}
                </strong>

                <div class="d-flex gap-1">

                    <button
                        type="button"
                         class="btn btn-primary-dark btn-sm rounded-3 text-x shadow me-2"
                        @click="addRecipient"
                    >
                        <i class="fas fa-plus text-white"></i>
                    </button>

                    <button
                        type="button"
                        class="btn btn-primary-dark btn-sm rounded-3 text-x shadow"
                        @click="removeRecipient(index)"
                    >
                        <i class="fas fa-trash text-white"></i>
                    </button>

                </div>

            </div>

            <div class="row">

                <div class="col-md-6 mb-3">

                    <label class="modal-form-label form-label text-xxs">
                        Recipient Type:
                    </label>

                    <select
                        v-model="recipient.recipient_type"
                        class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                        @change="
                            recipient.recipient_type === 'user'
                                ? recipient.role_id = null
                                : recipient.user_id = null
                        "
                    >

                        <option value="">
                            Select Recipient Type
                        </option>

                        <option value="user">
                            User
                        </option>

                        <option value="role">
                            Role
                        </option>

                    </select>

                </div>

                <div
                    v-if="recipient.recipient_type === 'user'"
                    class="col-md-6 mb-3"
                >

                    <label class="modal-form-label form-label text-xxs">
                        User:
                    </label>

                    <select
                        v-model="recipient.user_id"
                        class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                    >

                        <option value="">
                            Select User
                        </option>

                        <option
                            v-for="user in users"
                            :key="user.id"
                            :value="user.id"
                        >
                            {{ user.name }}
                        </option>

                    </select>

                </div>

                <div
                    v-else-if="recipient.recipient_type === 'role'"
                    class="col-md-6 mb-3"
                >

                    <label class="modal-form-label form-label text-xxs">
                        Role:
                    </label>

                    <select
                        v-model="recipient.role_id"
                        class="modal-form-control form-select text-xxs rounded-small p-2 shadow-sm"
                    >

                        <option value="">
                            Select Role
                        </option>

                        <option
                            v-for="role in user_roles"
                            :key="role.id"
                            :value="role.id"
                        >
                            {{ role.role }}
                        </option>

                    </select>
                </div>
            </div>
        </div>
    </div>

    <div
        v-else
        class="text-muted text-xxs"
    >
        No recipients configured.
    </div>

</div>

 <div class="mb-4">
    <div class="mb-2">
        <h6 class="modal-form-label form-label text-xxs">
            Conditions
        </h6>
    </div>

    <div
        v-if="
            selected_notification.conditions &&
            selected_notification.conditions.length > 0
        "
    >
        <div
            v-for="(condition, index) in selected_notification.conditions"
            :key="condition.id || index"
            class="border rounded-3 p-3 mb-2"
        >
            <div
                class="d-flex justify-content-between align-items-center mb-3"
            >
                <strong class="text-xs">
                    Condition {{ index + 1 }}
                </strong>

                <div class="d-flex gap-1">
                    <button
                        type="button"
                        class="btn btn-primary-dark btn-sm rounded-3 text-x shadow me-2"
                        @click="addCondition"
                    >
                        <i class="fas fa-plus text-white"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary-dark btn-sm rounded-3 text-x shadow"
                        @click="removeCondition(index)"
                    >
                        <i class="fas fa-trash text-white"></i>
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <label class="text-xs fw-semibold">
                        Entity type
                    </label>

                    <select
                        class="form-select"
                        v-model="condition.field_name"
                    >
                        <option value="">
                            Select Field
                        </option>

                        <option
                            v-for="field in field_options"
                            :key="field.value"
                            :value="field.value"
                        >
                            {{ field.label }}
                        </option>
                    </select>
                </div>

                <div class="col-md-3">
                    <label class="text-xs fw-semibold">
                        Operator
                    </label>

                    <select
                        class="form-select"
                        v-model="condition.operator"
                    >
                        <option value="">
                            Select Operator
                        </option>

                        <option
                            v-for="operator in operator_options"
                            :key="operator.value"
                            :value="operator.value"
                        >
                            {{ operator.label }}
                        </option>
                    </select>
                </div>

                <div class="col-md-5">
                    <label class="text-xs fw-semibold">
                        Value
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Enter comparison value"
                        v-model="condition.value"
                    >
                </div>
            </div>
        </div>
    </div>
    <div
        v-else
        class="text-muted text-xxs mb-2"
    >
        No conditions configured.
    </div>

    <div class="mt-2">
        <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-3 text-x shadow"
            @click="addCondition"
        >
            <i class="fas fa-plus text-white me-1"></i>
            Add Condition
        </button>
    </div>
</div>
</div>

                <div class="modal-footer border-0 p-3 d-flex justify-content-end gap-2">
                    <div>
                        <button
                            type="button"
                            class="btn entity-assign-btn btn-sm rounded-small fw-semibold "
                            @click="update_notification"
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</teleport>